import React from 'react';
import './Gallery.css';
import { galleryImages } from '../data/newsData';

function Gallery() {
  const [selectedImage, setSelectedImage] = React.useState(null);

  return (
    <div className="gallery-page">
      {/* Header */}
      <section className="gallery-header" aria-labelledby="gallery-title">
        <div className="container">
          <h1 id="gallery-title">📸 गैलरी</h1>
          <p className="gallery-subtitle">
            हमारे राजनीतिक कार्यक्रमों और महत्वपूर्ण क्षणों की झलक
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-content">
        <div className="container">
          <div className="gallery-grid">
            {galleryImages.map(image => (
              <div
                key={image.id}
                className="gallery-item"
                onClick={() => setSelectedImage(image)}
                tabIndex={0}
                role="button"
                onKeyDown={(e) => e.key === 'Enter' && setSelectedImage(image)}
              >
                <img src={image.url} alt={image.title} loading="lazy" />
                <div className="gallery-overlay">
                  <p>{image.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <button
            className="lightbox-close"
            onClick={() => setSelectedImage(null)}
            aria-label="बंद करें"
          >
            ✕
          </button>
          <img src={selectedImage.url} alt={selectedImage.title} />
          <p className="lightbox-title">{selectedImage.title}</p>
        </div>
      )}
    </div>
  );
}

export default Gallery;